var map = {
	"./arrow.png": 4931,
	"./card-interazione/applausometro.png": 1661,
	"./card-interazione/polls.png": 6363,
	"./card-interazione/qna.png": 9119,
	"./card-interazione/quiz.png": 2898,
	"./card-interazione/selfie-wall.png": 8795,
	"./card-interazione/wordcloud.png": 7500,
	"./card_1.png": 8134,
	"./card_2.png": 8177,
	"./card_3.png": 8389,
	"./come-1.png": 7248,
	"./come-2.png": 9433,
	"./come-3.png": 7787,
	"./come-visual.png": 5428,
	"./compagno-perfetto/1.png": 8061,
	"./compagno-perfetto/2.png": 4618,
	"./compagno-perfetto/3.png": 4839,
	"./compagno-perfetto/4.png": 9491,
	"./compagno-perfetto/5.png": 1453,
	"./compagno-perfetto/6.png": 5679,
	"./compagno-perfetto/7.png": 7956,
	"./compagno-perfetto/8.png": 3808,
	"./demo-card-bkg.png": 9871,
	"./logo_header.png": 4242,
	"./logo_header_by_plesh.png": 8920,
	"./logo_header_mobile_big.png": 9238,
	"./logo_header_mobile_big_by_plesh.png": 6425,
	"./logo_white.png": 1203,
	"./main-visual/card1.png": 4375,
	"./main-visual/card2.png": 8608,
	"./main-visual/card3.png": 1010,
	"./main-visual/card4.png": 8884,
	"./main-visual/cards.png": 2867,
	"./main-visual/icone.png": 1410,
	"./main-visual/mano.png": 9836,
	"./main-visual/ondaDx.png": 9223,
	"./main-visual/ondaMobile.png": 6520,
	"./main-visual/ondaSx.png": 5387,
	"./main.png": 5530,
	"./mano.png": 2514,
	"./play-button.png": 4947,
	"./rivolto-a-chi/1.png": 8334,
	"./rivolto-a-chi/2.png": 4021,
	"./rivolto-a-chi/3.png": 5835,
	"./rivolto-a-chi/4.png": 5958,
	"./rivolto-visual-mobile.png": 2465,
	"./rivolto-visual.png": 490
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;